import { render, staticRenderFns } from "./ProtectionJuridique.vue?vue&type=template&id=57cf49b0&scoped=true&"
import script from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
import style0 from "./ProtectionJuridique.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProtectionJuridique.vue?vue&type=style&index=1&id=57cf49b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf49b0",
  null
  
)

export default component.exports